import React from 'react';
import { BuilderPage } from '../components/builder/BuilderPage';
import { BUILDER_FIGMA_MODEL, BUILDER_STARTUP_PAGE_URL } from '../config/builder';

const LandingStartupPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <BuilderPage urlPath={BUILDER_STARTUP_PAGE_URL} model={BUILDER_FIGMA_MODEL} />
    </div>
  );
};

export default LandingStartupPage;
